<template>
  <div class="">
    <v-dialog
        v-model="dialog"
        max-width="950"
        min-height="335"
        :content-class="$vuetify.breakpoint.smAndDown ? 'v-dialog_modal elevation-0 small-view' : 'v-dialog_modal elevation-0'"
    >
      <v-btn icon color="primary" @click="dialog = false" class="btn_close">
      </v-btn>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
            class="buy_btn  mb-sm-0 disable-events"
            width="110px"
            height="50px"
            outlined
            rounded
            color="#2C4370"
            v-bind="attrs"
            v-on="on"
            v-ripple="false"
        >
          Buy
        </v-btn>
      </template>
      <v-card class="v-dialog_card">
        <v-row class="flex-wrap flex-column flex-md-row">
          <v-col cols="12" md="6" class="no-gutters order-1 order-md-0" style="padding-top: 5px">
            <v-card-title class="mb-5 text-h5 text-md-h4"
            >Select {{ typeProduct }}
            </v-card-title
            >
            {{ tmpMessage }}
            <div
                class="
                d-flex
                flex-column flex-md-row flex-wrap
                align-center
                justify-center
                mt-0
                mb-5
                mt-lg-0
              "
            >
              <div>
                <div
                    class="
                    scroller
                    d-flex
                    ml-auto
                    mr-auto
                    align-center
                    mt-0 mt-lg-0
                  "
                >
                  <v-slider
                      thumb-color="#2C4370"
                      thumb-size="23px"
                      tick-size="10"
                      :loader-height="10"
                      hide-details=""
                      v-model="cnt"
                      track-color="#EEF4FF"
                      track-fill-color="#ACBFE3"
                      :min="min"
                      :max="max"
                      :step="1"
                      @change="changeSlider"
                  ></v-slider>
                </div>
              </div>

              <div>
                <div
                    class="
                    d-flex
                    align-center
                    justify-center
                    ml-n6
                    mt-4 mt-lg-0
                    ml-lg-5
                    mr-n8 mr-lg-5
                  "
                >
                  <img
                      :src="img"
                      width="25"
                      height="25"
                      alt=""
                  />
                  <div class="ml-2">
                    <div class="followers">
                      <v-text-field
                          ref="countInput"
                          type="number"
                          class="v-text-input counter-input"
                          v-model="cnt"
                          :min="min"
                          :max="max"
                          :step="1"
                          @change="changeInput"
                          @click="clickll"
                          @blur="validateInput"
                          @keyup="changeInput"
                      ></v-text-field>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="px-4 px-sm-0">
                <v-btn class="btn_order_followers" @click="setBuySingle">
                    <span class="text">Order {{ typeProduct }}</span>
                    <span class="price">{{ price }}$</span>
                </v-btn>
            </div>
          </v-col>
          <v-col cols="12" md="6" class="no-gutters order-0 order-md-1" style="padding-bottom: 5px">
            <picture>
              <source
                  class="order-img-mob"
                  media="(max-width: 767px)"
                  srcset="../assets/order-follower-img-767.svg"
              />
              <img
                  class="order-img"
                  src="../assets/order-follower-img.svg"
                  alt="order-follower"
              />
            </picture>
          </v-col>
        </v-row>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { buySingle } from '@/api/biling'
import { updateCounts } from '../utils/utils'
import vue from 'vue'

export default {
  props: ['slug', 'typeProduct', 'singleData'],
  data () {
    return {
      dialog: false,
      cnt: 0,
      min: 0,
      max: 0,
      step: 0,
      singleCost: 0,
      data: {},
      selectData: false,
      price: 0,
      tmpMessage: '',
    }
  },
  mounted () {
    setTimeout(() => {
      this.min = this.singleData[this.slug][this.typeProduct].min
      this.max = this.singleData[this.slug][this.typeProduct].max
      this.step = 1
      this.singleCost = this.singleData[this.slug][this.typeProduct].single
      this.data = this.singleData[this.slug][this.typeProduct].data
      this.cnt = this.min
      this.getCost()
    }, 500)
  },
  methods: {
    clickll () {
      this.getCost()
    },
    validateInput (event) {
      const count = updateCounts(event, this.min, this.max)
      event.target.value = count
      this.$refs.countInput.lazyValue = count
      this.$refs.countInput.initialValue = count
      vue.set(this, 'cnt', count)
      this.getCost()
    },
    changeInput () {
      this.getCost()
    },
    changeSlider () {
      this.getCost()
    },
    getCost () {
      this.selectData = false
      for (var keyCnt in this.data) {
        if (!this.selectData) {
          this.selectData = this.data[keyCnt]
        }

        var keyCntInt = parseInt(keyCnt)
        if (keyCntInt > this.cnt) {
          break
        }
        this.selectData = this.data[keyCnt]
      }
      console.log(this.selectData)

      let cf = this.selectData.cf
      this.step = this.selectData.step

      let price = this.singleCost * this.cnt * cf

      // this.tmpMessage = 'price not round='+price.toString()+' coefficient='+cf.toString()+' step ='+this.step;

      // price = Math.floor(price*10)/10
      // price += 0.09;
      price = Math.floor(price * 100) / 100

      this.price = price

      // console.log(price, 'price')
      // console.log(cf, 'cf')
    },

    setBuySingle () {
        let redirect = null;
        let back = window.location.href;

        if (window.location.pathname !== '/dashboard') {
            redirect = window.location.href+'?message=Balance added successfully to your account';
        }

      buySingle({
        slug: this.slug,
        typeProduct: this.typeProduct,
        cnt: this.cnt,
        price: this.price,
        redirect,
        back,
      })
          .then((data) => {
                if (data.payment_url) {
                    window.location.href = data.payment_url;
                }
          })
          .catch((error) => {
            console.log(error)
          })
    },
  },
  computed: {
    img() {
      switch (this.typeProduct) {
        case 'followers':
          return '../assets/' + this.typeProduct + '.svg';
        case 'likes':
          return '../assets/like.svg';
        case 'comments':
          return '../assets/message.svg';
        case 'views':
          return '../assets/eye.svg';
      }
      return  '../assets/' + this.typeProduct + '.svg';
    }
  }
}
</script>
<style scoped>
.disable-events::before {
  display: none;
}
.v-dialog.small-view {
  margin-top: 0px;
}

.v-dialog_modal {
  background: #ffffff;
  border-radius: 20px;
  overflow: unset !important;
  height: 335px;
}

.v-dialog {
  box-shadow: none !important;
}

>>> .v-dialog {
  overflow-y: visible;
}

picture {
  margin-left: -25px;
}

.v-dialog .order-img {
  width: 486px;
  height: 388px;
  object-fit: contain;
  margin-top: -45px;
}

.v-dialog_card {
  background: #ffffff;
  border-radius: 20px;
  overflow: unset;
  height: 335px;
}
@media (max-width: 959px) {
    .v-dialog_card {
        height: auto;
    }
}


.v-sheet.v-card {
  border-radius: 20px;
}

.v-card__title {
  display: block;
  width: 100%;
  font-weight: bold;
  font-size: 36px;
  line-height: 44px;
  text-align: center;
  color: #172745;
  padding-top: 50px;
  box-sizing: border-box;
  text-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  margin-bottom: 0px !important;
}

.btn_order_followers {
  display: flex;
  flex: 1 0 auto;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  min-width: 282px;
  height: 60px !important;
  background-color: #76cd68 !important;
  border-radius: 40px;
  width: 100%;
  max-width: 315px;
}

.btn_order_followers .text {
  font-style: normal;
  font-size: 18px;
  line-height: 22px;
  text-align: center;
  color: #ffffff;
  text-transform: none;
}

.btn_order_followers .price {
  display: flex;
  flex: 1 0 auto;
  align-items: center;
  justify-content: center;
  min-width: 84px;
  width: 115px;
  height: 35px;
  background: #4c983f;
  border-radius: 40px;
  font-weight: bold;
  font-size: 18px;
  line-height: 22px;
  text-align: center;
  color: #ffffff;
  margin-left: 10px;
  padding: 0 17px;
}

.scroller {
  width: 226px;
}

.scroller >>> .v-slider--horizontal .v-slider__track-container {
  height: 10px !important;
  border-radius: 56px !important;
  overflow: hidden !important;
}

.scroller >>> .v-slider__thumb {
  height: 23px;
  width: 23px;
  border: 3px solid #fff !important;
}

.scroller >>> .v-slider__track-container {
  height: 10px !important;
}

.scroller >>> .v-slider__thumb:before {
  left: -10px;
  top: -9px;
}

.followers {
  width: 134px;
  margin-left: 10px;
}

.v-text-input {
  font-weight: normal;
  font-size: 20px !important;
  line-height: 24px;
  color: #172745 !important;
}

.v-btn--icon.v-size--default .v-icon {
  font-size: 57px;
  width: 57px !important;
  height: 57px !important;
}

.btn_close {
  width: 57px !important;
  height: 57px !important;
  margin-left: auto;
  display: block;
  background-image: url("../assets/close.svg");
  background-repeat: no-repeat;
  margin-bottom: 35px;
}

.small-view .btn_close {
  margin-bottom: 20px;
  width: 37px !important;
  height: 37px !important;
  background-size: 37px;
}
.v-dialog {
  margin-top: 12px !important;
}
@media (max-width: 767px) {
  .v-dialog_modal {
    width: 340px;
    height: 534px;
  }

  .v-dialog {
    height: 534px;
  }

  .v-card__title {
    padding-top: 0;
  }

  .btn_order_followers {
    margin-bottom: 30px;
  }

  picture {
    padding-top: 5px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .counter-input input {
    height: 32px;
  }

  .order-img-mob {
    display: none;
  }

  .v-dialog .order-img {
    display: block;
    width: 224px;
    height: 172px;
    margin: 0 auto;
  }

  .buy_btn::before {
    display: none;
  }
}
</style>
